module.exports = __webpack_public_path__ + "img/leader.3491afe9.jpg";